import { render, staticRenderFns } from "./updatamechanicalarm.vue?vue&type=template&id=0a0db9f2"
import script from "./updatamechanicalarm.vue?vue&type=script&lang=js"
export * from "./updatamechanicalarm.vue?vue&type=script&lang=js"
import style0 from "./updatamechanicalarm.vue?vue&type=style&index=0&id=0a0db9f2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports